import {
  Card,
  Divider,
  Grid,
  Typography,
  Snackbar,
  Alert as MuiAlert,
  Pagination,
  Button,
  CardContent,
  Accordion as MuiAccordion,
  AccordionSummary as MuiAccordionSummary,
  AccordionDetails as MuiAccordionDetails,
  Stack,
  TextField,
  Box
} from '@mui/material'
import {
  Add as AddIcon,
  ArrowForwardIosSharp,
  ExpandMore
} from '@mui/icons-material'
import React, { useEffect, useState, forwardRef } from 'react'
import { styled } from '@mui/material/styles'
import { Helmet } from 'react-helmet-async'
import { useNavigate } from 'react-router-dom'
import { businessCheck } from '../../utils/utils'
import OutletDialog from '../outlet/outlet/outletDialog'
import OutletInfoDrawer from '../outlet/outlet/outletInfoDrawer'
import FranchiseOptionsDialog from './FranchiseOptionsDialog'
import {
  ErrorScreen,
  SnackBarHideDuration,
  SnackBarTransition,
  SubBusinessFilter
} from '../../utils/ui_utils'
import { ShowNoRecordsFound } from '../../utils/ui_utils'
import EditOutlet from '../outlet/outlet/outletAccordion'
import {
  useCreateOutlet,
  useFetchOutlet,
  useFetchSubBusiness,
  useUpdateOutlet
} from '../../modules/outlet/outletHooks'
import ListTypeShimmer from '../../utils/ui_components/shimmers/listTypeShimmer'
import { getUserType } from '../../components/AuthGuard'
import { useBusinessFetch } from '../../modules/business/businessHooks'
import UserDialog from '../user/user/userDialog'
import {
  useCreateUser,
  useSendAdminOtp,
  useVerifyAdminOtp
} from '../../modules/user/userHooks'

function Franchise() {
  const [page, setPage] = useState(1)
  const [limit, setLimit] = useState(10)
  const [pagecount, setPageCount] = useState(1)
  const [goToPageInput, setGoToPageInput] = useState('')
  const [outletDialogMode, setoutletDialogMode] = useState('edit')
  const [snackbar, setSnackBar] = useState(false)
  const [PopUpMessage, setPopUpMessage] = useState(null)
  const [severity, setSeverity] = useState(null)
  const [initialValue, setInitialValue] = useState({})
  const [outletDialogVisibility, setOutletDialogVisibility] = useState(false)
  const [outletInfoDrawerVisibility, setOutletInfoDrawerVisibility] =
    useState(false)
  const [outletData, setOutletData] = useState([])
  const userType = getUserType()
  const { outletFetch, outletFetchData, outletFetchError, outletFetchLoading } =
    useFetchOutlet()
  const { outletCreate, outletCreateLoading } = useCreateOutlet()
  const { outletUpdate } = useUpdateOutlet()
  const handleSnackbarClose = () => {
    setSnackBar(false)
  }
  const Alert = forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />
  })
  const { fetchBusiness, businessLoading, businessData, businessError } =
    useBusinessFetch()
  const [allowBusinessCreation, setAllowBusinessCreation] = useState(false)
  const toastMessage = (message, severity) => {
    setPopUpMessage(message)
    setSeverity(severity)
    setSnackBar(true)
  }
  const history = useNavigate()
  const handlePageChange = async (event, value) => {
    setPage(value)
    let payload = {
      pageNumber: value,
      limit: limit
    }
    outletFetch(payload)
  }

  const handleGoToPageChange = (event) => {
    const value = event.target.value
    if (/^\d+$/.test(value) || value === '') {
      setGoToPageInput(value)
    }
  }

  const handleGoToPageSubmit = () => {
    const pageNum = parseInt(goToPageInput, 10)
    if (pageNum >= 1 && pageNum <= pagecount) {
      handlePageChange(null, pageNum)
      setGoToPageInput('')
    }
  }

  const handleGoToPageKeyPress = (event) => {
    if (event.key === 'Enter') {
      handleGoToPageSubmit()
    }
  }

  const pageCount = (data1) => {
    let count = Math.ceil(data1 / limit)
    setPageCount(count)
  }

  const {
    fetch: fetchSubBusiness,
    data: subBusinessData,
    loading: subBusinessLoading
  } = useFetchSubBusiness()
  useEffect(() => {
    businessCheck(history)
    let payload = {
      pageNumber: page,
      limit: limit
    }
    outletFetch(payload)
    fetchBusiness(payload)
    fetchSubBusiness()
  }, [])

  useEffect(() => {
    if (outletFetchData.data?.length > 0) {
      pageCount(outletFetchData.total)
      setOutletData(outletFetchData?.data)
    } else {
      setOutletData([])
    }
  }, [outletFetchData])

  useEffect(() => {
    if (businessData?.data?.length > 0) {
      if (
        businessData?.data[0]?.multi_outlet ||
        (!businessData?.data[0]?.multi_outlet && outletData?.length === 0)
      ) {
        setAllowBusinessCreation(true)
      } else {
        setAllowBusinessCreation(false)
      }
    } else {
      setAllowBusinessCreation(false)
    }
  }, [businessData])

  const [expanded, setExpanded] = useState(false)

  const fetchOutletOnError = () => {
    let payload = {
      pageNumber: page,
      limit: limit
    }
    outletFetch(payload)
  }

  const handleExpandChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false)
  }

  const Accordion = styled((props) => (
    <MuiAccordion disableGutters elevation={10} {...props} />
  ))(({ theme }) => ({
    border: `1px solid ${theme.palette.divider}`,
    '&:before': {
      display: 'none'
    }
  }))

  const AccordionSummary = styled((props) => (
    <MuiAccordionSummary
      expandIcon={<ArrowForwardIosSharp sx={{ fontSize: '0.9rem' }} />}
      {...props}
    />
  ))(({ theme }) => ({
    backgroundColor:
      theme.palette.mode === 'dark'
        ? 'rgba(255, 255, 255, .05)'
        : 'rgba(0, 0, 0, .03)',
    flexDirection: 'row-reverse',
    '& .MuiAccordionSummary-content': {
      marginLeft: theme.spacing(1)
    },
    root: {
      '& .MuiAccordionSummary:nth-of-type(even)': {
        backgroundColor: 'rgba(0, 0, 0, 0)'
      }
    }
  }))

  const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
    padding: theme.spacing(2),
    borderTop: '1px solid rgba(0, 0, 0, .125)'
  }))

  const [showOutletSelection, setShowOutletSelection] = useState(false)
  const [createdOutlet, setCreatedOutlet] = useState(null)
  const [userDailogVisibility, setUserDailogVisibility] = useState(false)
  const [showOtpUI, setShowOtpUI] = useState(false)
  const { userSendAdminOtp, userSendOtploading } = useSendAdminOtp()
  const { userVerifyAdminOtp, userVerifyOtploading } = useVerifyAdminOtp()
  const { userCreate, userCreateError, userCreateloading } = useCreateUser()
  const [outletID, setOutletID] = useState(null)
  const sendOTP = (loginId) => {
    let requestOTP = { mobile: loginId }
    userSendAdminOtp(requestOTP, (success, error, message) => {
      if (error) {
        toastMessage(message, 'error')
      } else {
        toastMessage('OTP Sent', 'success')
        setShowOtpUI(true)
      }
    })
  }

  const createUser = async (values) => {
    values.role = values.user_type
    delete values.confirmPassword
    delete values.OTP
    await userCreate(values, (success, error, message) => {
      if (error) {
        let errorMessage = message || 'User creation failed'
        toastMessage(errorMessage, 'error')
        setShowOtpUI(false)
      } else {
        toastMessage('User Created.', 'success')
        setUserDailogVisibility(false)
        setShowOtpUI(false)
        setShowOutletSelection(false)
        setCreatedOutlet(null)
        setOutletID(null)
        let payload = {
          pageNumber: page,
          limit: limit
        }
        outletFetch(payload)
        fetchSubBusiness()
      }
    })
  }

  const resetState = () => {
    setCreatedOutlet(null)
    setShowOutletSelection(false)
    setUserDailogVisibility(false)
    setShowOtpUI(false)
    setOutletID(null)
    setShowFranchiseOptions(false)
  }

  const [selectedSubBusiness, setSelectedSubBusiness] = useState('')
  const [showFranchiseOptions, setShowFranchiseOptions] = useState(false)
  return (
    <>
      <Helmet title="Franchise" />
      <Grid
        container
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center'
        }}
      >
        <Grid item>
          <Typography variant="h4" gutterBottom display="inline">
            Franchise
          </Typography>
        </Grid>
        {!outletFetchError && userType === 'Owner' && allowBusinessCreation && (
          <Grid item justifyContent="space-between">
            <Button
              startIcon={<AddIcon />}
              variant="contained"
              color="primary"
              size="small"
              onClick={() => {
                setoutletDialogMode('new')
                setOutletDialogVisibility(true)
                setInitialValue(undefined)
              }}
            >
              Create Franchise
            </Button>
          </Grid>
        )}
      </Grid>
      <OutletDialog
        visible={outletDialogVisibility}
        title={'Create New Outlet'}
        okText={'Next'}
        forFranchiseCreation={true}
        onSkip={() => {
          setShowOutletSelection(true)
          setOutletDialogVisibility(false)
          // Skip the franchise options dialog and go directly to franchise owner creation
          setUserDailogVisibility(true)
          // Ensure franchise options dialog is not shown
          setShowFranchiseOptions(false)
        }}
        onSubmit={async (value, selfBusiness, isExistingSubBusiness) => {
          let values = _.cloneDeep(value)
          values.name = values.name.capitalizeFirstLetter()
          if (values.gstn === '') delete values.gstn
          if (values.fax === '') delete values.fax
          if (selfBusiness) {
            await outletCreate(values, (success, error, outlet_id) => {
              if (error) {
                let errorMessage = 'Outlet creation failed'
                toastMessage(errorMessage, 'error')
              } else {
                outletFetch({ pageNumber: page, limit: limit })
                setShowOutletSelection(false)
                setOutletDialogVisibility(false)
              }
            })
          } else {
            setCreatedOutlet(values)
            setShowOutletSelection(false)
            setOutletDialogVisibility(false)

            // Check if user typed a new sub-business name or selected an existing one
            if (
              isExistingSubBusiness &&
              values.sub_business_name &&
              values.sub_business_name.trim() !== ''
            ) {
              // Only show franchise options dialog if user selected an existing sub-business
              setShowFranchiseOptions(true)
            } else {
              // If user typed a new sub-business name or left it empty, go directly to franchise owner creation
              setUserDailogVisibility(true)
            }
          }
        }}
        initialValue={initialValue}
        onCancel={() => setOutletDialogVisibility(false)}
      />
      <Divider sx={{ marginTop: 5 }} />
      {!subBusinessLoading && (
        <SubBusinessFilter
          subBusinessData={subBusinessData}
          value={selectedSubBusiness}
          onClear={() => {
            setSelectedSubBusiness('')
            outletFetch({
              pageNumber: page,
              limit: limit
            })
          }}
          onChange={(e) => {
            setSelectedSubBusiness(e.target.value)
            outletFetch({
              pageNumber: page,
              limit: limit,
              by_sub_business_name: e.target.value
            })
          }}
        />
      )}
      {outletFetchError ? (
        <ErrorScreen
          onClick={() => {
            fetchOutletOnError()
          }}
        />
      ) : (
        <div>
          {outletFetchLoading && <ListTypeShimmer />}

          {!outletFetchLoading && outletData && outletData.length <= 0 && (
            <Grid
              container
              spacing={0}
              direction="column"
              alignItems="center"
              justifyContent="center"
              style={{ minHeight: '50vh' }}
            >
              <Grid item>
                <ShowNoRecordsFound />
              </Grid>
            </Grid>
          )}
          {!outletFetchError &&
            !outletFetchLoading &&
            outletData &&
            outletData.length > 0 && (
              <Grid
                container
                justifyContent="center"
                spacing={10}
                sx={{ paddingTop: 5 }}
              >
                <Grid item sm={8} md={8}>
                  <Card raised sx={{ borderRadius: 3 }}>
                    <CardContent sx={{ flexGrow: 1 }}>
                      <Stack spacing={3}>
                        {outletData.map((row, index) => {
                          return (
                            <Accordion
                              expanded={expanded === index}
                              onChange={handleExpandChange(index)}
                              key={index}
                            >
                              <AccordionSummary
                                expandIcon={<ExpandMore />}
                                aria-controls={`${index}a-content`}
                                id={`${index}a-header`}
                                sx={{
                                  '&:hover': {
                                    backgroundColor: '#eaf6ff'
                                  }
                                }}
                              >
                                <Grid container sx={{ ml: 5 }}>
                                  <Grid item xs sm md={5}>
                                    <Grid container direction="column">
                                      <Grid item>
                                        <Typography
                                          variant="h4"
                                          justifyContent={'center'}
                                          sx={{ mb: 0.5 }}
                                        >
                                          {row.name}{' '}
                                        </Typography>
                                      </Grid>
                                      <Grid item>
                                        <Typography
                                          variant="subtitle1"
                                          justifyContent={'center'}
                                          sx={{ mb: 0.5 }}
                                        >
                                          {row.sub_business_name}
                                        </Typography>
                                      </Grid>
                                    </Grid>
                                  </Grid>
                                </Grid>
                              </AccordionSummary>
                              <AccordionDetails>
                                <EditOutlet
                                  initialValue={row}
                                  okText={'Update'}
                                  onSubmit={async (val) => {
                                    let values = _.cloneDeep(val)
                                    values.name =
                                      values.name.capitalizeFirstLetter()
                                    if (values.gstn === '') delete values.gstn
                                    if (values.fax === '') delete values.fax
                                    values.id = values._id
                                    delete values._id
                                    delete values.business_id
                                    delete values.key
                                    await outletUpdate(
                                      values,
                                      (success, error, res) => {
                                        if (error) {
                                          toastMessage(res, 'error')
                                        } else if (success) {
                                          toastMessage(res, 'success')
                                          setOutletDialogVisibility(false)
                                          let payload = {
                                            pageNumber: page,
                                            limit: limit
                                          }
                                          outletFetch(payload)
                                          fetchSubBusiness()
                                        }
                                      }
                                    )
                                  }}
                                />
                              </AccordionDetails>
                            </Accordion>
                          )
                        })}
                      </Stack>
                    </CardContent>
                    {pagecount > 1 && (
                      <Box
                        sx={{
                          display: 'flex',
                          flexDirection: 'column',
                          gap: 2,
                          p: 2,
                          backgroundColor: 'grey.50',
                          borderRadius: 1
                        }}
                      >
                        <Box
                          sx={{
                            display: 'flex',
                            justifyContent: 'center',
                            width: '100%'
                          }}
                        >
                          <Pagination
                            page={page}
                            color="primary"
                            size="small"
                            count={pagecount}
                            showFirstButton
                            showLastButton
                            onChange={handlePageChange}
                            sx={{
                              '& .MuiPaginationItem-root': {
                                transition: 'all 0.2s ease-in-out'
                              }
                            }}
                          />
                        </Box>
                        <Box
                          sx={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            gap: 1.5,
                            backgroundColor: 'white',
                            p: 2,
                            borderRadius: 1,
                            boxShadow: '0 1px 3px rgba(0,0,0,0.08)',
                            transition: 'box-shadow 0.2s ease-in-out',
                            '&:hover': {
                              boxShadow: '0 2px 6px rgba(0,0,0,0.12)'
                            }
                          }}
                        >
                          <Typography
                            variant="body2"
                            sx={{ color: 'text.secondary', fontWeight: 500 }}
                          >
                            Jump to
                          </Typography>
                          <TextField
                            size="small"
                            value={goToPageInput}
                            onChange={handleGoToPageChange}
                            onKeyPress={handleGoToPageKeyPress}
                            placeholder="Page"
                            sx={{
                              width: '80px',
                              '& .MuiOutlinedInput-root': {
                                backgroundColor: 'white',
                                transition: 'all 0.2s ease-in-out',
                                '& fieldset': {
                                  borderColor: 'grey.300',
                                  borderWidth: '1px'
                                },
                                '&:hover fieldset': {
                                  borderColor: 'primary.main',
                                  borderWidth: '1.5px'
                                },
                                '&.Mui-focused fieldset': {
                                  borderColor: 'primary.main',
                                  borderWidth: '2px',
                                  boxShadow: '0 0 0 3px rgba(33, 150, 243, 0.1)'
                                }
                              },
                              '& .MuiOutlinedInput-input': {
                                textAlign: 'center',
                                fontWeight: 500,
                                padding: '7px 8px',
                                height: '20px',
                                lineHeight: '20px'
                              }
                            }}
                          />
                          <Typography
                            variant="body2"
                            sx={{ color: 'text.secondary', fontWeight: 400 }}
                          >
                            of {pagecount}
                          </Typography>
                          <Button
                            variant="contained"
                            color="primary"
                            size="small"
                            onClick={handleGoToPageSubmit}
                            disabled={
                              !goToPageInput ||
                              parseInt(goToPageInput, 10) < 1 ||
                              parseInt(goToPageInput, 10) > pagecount
                            }
                            sx={{
                              textTransform: 'none',
                              fontWeight: 500,
                              px: 2,
                              py: 0.75,
                              height: '34px',
                              lineHeight: 1,
                              transition: 'all 0.2s ease-in-out',
                              '&:hover': {
                                transform: 'translateY(-1px)',
                                boxShadow: '0 4px 8px rgba(33, 150, 243, 0.3)'
                              },
                              '&:active': {
                                transform: 'translateY(0)'
                              }
                            }}
                          >
                            Go
                          </Button>
                        </Box>
                      </Box>
                    )}
                  </Card>
                </Grid>
              </Grid>
            )}
        </div>
      )}

      <OutletInfoDrawer
        visible={outletInfoDrawerVisibility}
        outletdata={initialValue}
        closeText="Close"
        onClose={() => setOutletInfoDrawerVisibility(false)}
        title="Franchise Info"
      />
      <Snackbar
        open={snackbar}
        autoHideDuration={SnackBarHideDuration}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
        onClose={handleSnackbarClose}
        TransitionComponent={SnackBarTransition}
      >
        <Alert onClose={handleSnackbarClose} severity={severity}>
          {PopUpMessage}
        </Alert>
      </Snackbar>
      <UserDialog
        mode="new"
        forFranchise={true}
        loading={
          userCreateloading ||
          outletCreateLoading ||
          userSendOtploading ||
          userVerifyOtploading
        }
        outletName={createdOutlet?.name}
        showOutletSelection={showOutletSelection}
        onClose={resetState}
        onResendOTP={(mobile) => sendOTP(mobile)}
        onSubmit={async (value) => {
          let values = _.cloneDeep(value)
          if (!showOtpUI) {
            sendOTP(values.mobile)
          } else {
            if (values.OTP.length < 4) return
            let payload = {
              mobile: values.mobile,
              otp: values.OTP
            }
            await userVerifyAdminOtp(
              payload,
              async (success, error, message) => {
                if (error) {
                  toastMessage(message, 'error')
                  return
                } else {
                  toastMessage('OTP Verified', 'success')
                  if (showOutletSelection || userCreateError) {
                    values.outlet = outletID ? outletID : values.outlet
                    await createUser(values)
                  } else {
                    await outletCreate(
                      createdOutlet,
                      async (success, error, outlet_id) => {
                        if (error) {
                          let errorMessage = 'Outlet creation failed'
                          toastMessage(errorMessage, 'error')
                          resetState()
                        } else {
                          setOutletID([outlet_id])
                          values.outlet = [outlet_id]
                          await createUser(values)
                        }
                      }
                    )
                  }
                }
              }
            )
          }
        }}
        visible={userDailogVisibility}
        title={'Create FOwner'}
        okText={'Create'}
        showOTPui={showOtpUI}
        onCancel={() => {
          setUserDailogVisibility(false)
          setShowOtpUI(false)
        }}
      />
      <FranchiseOptionsDialog
        open={showFranchiseOptions}
        onClose={() => {
          setShowFranchiseOptions(false)
          resetState()
        }}
        onExistingOwner={() => {
          setShowFranchiseOptions(false)

          // Directly create outlet/franchise with existing owner
          if (createdOutlet) {
            outletCreate(createdOutlet, (success, error, outlet_id) => {
              if (error) {
                let errorMessage = 'Franchise creation failed'
                toastMessage(errorMessage, 'error')
                resetState()
              } else {
                toastMessage('Franchise created successfully', 'success')
                let payload = {
                  pageNumber: page,
                  limit: limit
                }
                outletFetch(payload)
                fetchSubBusiness()
                resetState()
              }
            })
          } else {
            toastMessage('Error: Franchise details not available', 'error')
            resetState()
          }
        }}
        onNewOwner={() => {
          setShowFranchiseOptions(false)
          setUserDailogVisibility(true)
        }}
      />
    </>
  )
}

export default Franchise
